import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  EnvironmentModel,
  EnvironmentType,
  GocooEngineConfig,
  LoginUserUtility,
  UserModel,
} from '@ktvs8/gocoo-engine-front-end';
import menu from '../app/develop/config/menu.json';
import { ENV_TYPE } from './build-env';
import { GetGocooEngineApplicationUserInfo, GocooEngineDevelopViewInfoList } from './develop/gocoo-engine-handler';
import { MockBacEndServerClass } from './develop/mock-back-end-sever-class';
import { UserRole } from './utility/application-user-utility';
/**
 * アプリケーションのルートコンポーネント
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
/**
 * アプリケーションのルートコンポーネント
 */
export class AppComponent {
  title = '発注書交付システム';

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router
  ) {
    GocooEngineConfig.loginUser = new UserModel();

    // メニューの情報を指定
    GocooEngineConfig.menuInfoItem = menu;

    // 環境を構築
    setEnvironment();

    // モックデータを設定
    setMockServer();

    // ローカル環境で実行する際のテストユーザーを設定
    setLocalExecuting();
  }
}

/**
 * GocooEngineConfig.environmentの設定を実施
 */
export function setEnvironment() {
  GocooEngineConfig.environment = new EnvironmentModel();

  // 画面構成を管理したリストを設定
  GocooEngineConfig.environment.developViewInfoList = GocooEngineDevelopViewInfoList;

  // 実行環境を指定
  switch (ENV_TYPE) {
    case 'dev':
      GocooEngineConfig.environment.environmentType = EnvironmentType.StationDev;
      break;
    case 'test':
      GocooEngineConfig.environment.environmentType = EnvironmentType.StationTest;
      break;
    case 'stg':
      GocooEngineConfig.environment.environmentType = EnvironmentType.Staging;
      break;
    case 'prod':
      GocooEngineConfig.environment.environmentType = EnvironmentType.Production;
      break;
    default:
      throw new Error(`Unsupported ENV_TYPE: ${ENV_TYPE}`);
  }

  // システム名を設定
  GocooEngineConfig.environment.systemName = 'ordersheet-issue';

  // アプリケーションユーザーの画面情報などを設定
  GocooEngineConfig.environment.applicationUser = GetGocooEngineApplicationUserInfo();
}

/**
 * ローカル実行する際の設定を実施
 * @returns
 */
export function setLocalExecuting() {
  if (
    GocooEngineConfig.environment.environmentType !== EnvironmentType.UseMock &&
    GocooEngineConfig.environment.environmentType !== EnvironmentType.DevelopmentBackendServer
  ) {
    return;
  }

  const setUser = () => {
    GocooEngineConfig.loginUser = new UserModel();
    GocooEngineConfig.loginUser.mailAddress = 'test@teset';
    GocooEngineConfig.loginUser.userName = 'テストユーザー';
    GocooEngineConfig.loginUser.userRole = UserRole.ProductionManager;

    LoginUserUtility.refreshLoginUserInfo();
  };

  const setDomain = () => {
    GocooEngineConfig.environment.originUrl = 'http://localhost:4200';
    GocooEngineConfig.environment.importCssFileUrl = '/assets/css';
  };

  setUser();
  setDomain();
}

/**
 * Mock serverの設定を実施
 */
export function setMockServer() {
  if (GocooEngineConfig.environment.environmentType !== EnvironmentType.UseMock) {
    return;
  }

  GocooEngineConfig.environment.mockBackEndServer = new MockBacEndServerClass();
}
